import classes from "./DetailsLayout.module.scss";
import type { TestimonialProps } from "./DetailsLayoutProps";

export function Testimonial({ quote }: TestimonialProps) {
  return (
    <div className={classes.testimonial}>
      <div className={classes.testimonial__picture}>
        <img src={quote.image} alt="" />
      </div>
      <div className={classes.testimonial__content}>
        <div className={classes.testimonial__quote}>{quote.text}</div>
        <p className={classes.testimonial__author}>{quote.author}</p>
      </div>
    </div>
  );
}
